import { v4 } from 'uuid';
import { assignOid, maybeGetOid } from './oids.js';
export function take(obj, keys) {
    const result = {};
    for (const key of keys) {
        result[key] = obj[key];
    }
    return result;
}
export function omit(obj, keys) {
    const result = {};
    for (const key of Object.keys(obj)) {
        if (!keys.includes(key)) {
            result[key] = obj[key];
        }
    }
    return result;
}
export function getSortedIndex(array, insert, compare) {
    let low = 0;
    let high = array.length;
    while (low < high) {
        const mid = (low + high) >>> 1;
        const cmp = compare(array[mid], insert);
        if (cmp < 0) {
            low = mid + 1;
        }
        else {
            high = mid;
        }
    }
    return low;
}
function orderedReplacer(_, v) {
    if (typeof v !== 'object' || v === null || Array.isArray(v)) {
        return v;
    }
    return Object.fromEntries(Object.entries(v).sort(([ka], [kb]) => (ka < kb ? -1 : ka > kb ? 1 : 0)));
}
/**
 * Consistently stringifies an object regardless
 * of key insertion order
 */
export function stableStringify(obj) {
    return JSON.stringify(obj, orderedReplacer);
}
export function cloneDeep(obj) {
    if (isObject(obj)) {
        const oid = maybeGetOid(obj);
        let clone;
        if (Array.isArray(obj)) {
            clone = obj.map(cloneDeep);
        }
        else {
            clone = {};
            for (const [key, value] of Object.entries(obj)) {
                clone[key] = cloneDeep(value);
            }
        }
        if (oid) {
            assignOid(clone, oid);
        }
        return clone;
    }
    return obj;
}
// TODO: better hash
export function hashObject(obj) {
    return stableStringify(obj);
}
export function isObject(obj) {
    return obj && typeof obj === 'object';
}
export function roughSizeOfObject(object) {
    var objectList = [];
    var stack = [object];
    var bytes = 0;
    while (stack.length) {
        var value = stack.pop();
        if (typeof value === 'boolean') {
            bytes += 4;
        }
        else if (typeof value === 'string') {
            bytes += value.length * 2;
        }
        else if (typeof value === 'number') {
            bytes += 8;
        }
        else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
            objectList.push(value);
            for (var i in value) {
                stack.push(value[i]);
            }
        }
    }
    return bytes;
}
export function assert(condition, message = 'assertion failed') {
    if (!condition) {
        throw new Error(message);
    }
}
export function generateId(length = 16) {
    return v4().replace('-', '').slice(0, length);
}
export function findLastIndex(array, predicate) {
    for (let i = array.length - 1; i >= 0; i--) {
        if (predicate(array[i])) {
            return i;
        }
    }
    return -1;
}
//# sourceMappingURL=utils.js.map